import React from 'react';
import Slider from 'react-slick';

import SvgIcon from "../../SharedComponents/Icons";
import { contractsData } from '../data';
import ContractBox from "../ContractBox";

import './index.sass';


const ContractsList = ({ paymentType }) => {

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <div className="testimonials__prev-btn"><SvgIcon name="keyboard-arrow-left-rounded-ios" size={32} /></div>,
    nextArrow: <div className="testimonials__next-btn"><SvgIcon name="keyboard-arrow-right-rounded-ios" size={32} /></div>,
  };

  const contracts = Object.keys(contractsData).map(contract =>
    <ContractBox
      contract={contractsData[contract]}
      paymentType={paymentType}
      key={contractsData[contract].accountType}
    />
  );

  return (
    <div className="contracts-list">
      <Slider {...settings}>
        { contracts }
      </Slider>

      <div className="contracts-list__contracts-desktop">
        { contracts }
      </div>
    </div>
  )
}

export default ContractsList;
